export const ENGLISH = 'english';
export const CANTONESE = 'cantonese';
export const PUTONGHUA = 'putonghua';

export const lang = {
    [ENGLISH]:{
        "audio": {
            "folder": "English",
            "suffix": "_E"
        }
    },
    [CANTONESE]:{
        "audio": {
            "folder": "Cantonese",
            "suffix": "_C"
        }
    },
    [PUTONGHUA]:{
        "audio": {
            "folder": "Putonghua",
            "suffix": "_P"
        }
    }
}